module.exports = __webpack_public_path__ + "assets/youjian.4fd7598bccf26187dc5162f2ec3c5e49.png";